import React from "react";
import dynamic from "next/dynamic";

import { Banner } from "../../Banners/PromotionBanner";
import { FixedBanner } from "../../Banners/FixedBanner";
import { ProductFilters } from "../../Filters/ProductFilters";
import { Tips } from "../../Tips";
import { CardOrientation } from "../CardOrientation";
import { ProductList } from "../ProductList";
import { DetailModalProvider } from "../../../../common/components/DetailModalProvider";
import { ProductsContextProvider } from "../state/products";
import { ProductsTotalResults } from "../TotalResults/ProductsTotalResults";
import { Head } from "../Head";
import { isTravel } from "../../../helpers/isTravel";
import { TopDestinations } from "../../Content/TravelBrazil/TopDestinations";

import { ILayoutProps } from "./types";
import { TopDestinationsProps } from "../../../components/Content/TravelBrazil/TopDestinations";

export interface ResultsProps extends Pick<TopDestinationsProps, "destinations"> {
  Layout: React.ComponentType<ILayoutProps>;
  businessCode: string;
  hasSelectedFilters: boolean;
}

const TravelBrazilContent = dynamic(() =>
  import("../../Content/TravelBrazil").then(c => c.SeguroViagem)
);

const isTravelBrazil = (businessCode: string) => businessCode === "travel-insurance-br";

export const Results: React.FC<ResultsProps> = ({
  Layout,
  businessCode,
  hasSelectedFilters,
  destinations
}) => (
  <ProductsContextProvider>
    <DetailModalProvider>
      <Head />
      <Layout
        renderCardOrientation={<CardOrientation />}
        renderResult={<ProductList />}
        renderFilter={<ProductFilters />}
        renderTips={<Tips />}
        renderTotalResults={<ProductsTotalResults />}
        renderBanner={
          <>
            <Banner />
            <FixedBanner />
          </>
        }
      />
    </DetailModalProvider>
    {!hasSelectedFilters && isTravelBrazil(businessCode) && <TravelBrazilContent />}
    {!hasSelectedFilters && isTravel(businessCode) && (
      <TopDestinations destinations={destinations} />
    )}
  </ProductsContextProvider>
);
